module.exports = window.Shiny;